// Util
import { DateUtil } from '@/utils/dateutil';

// Others
import axios from 'axios';
import config from '@/config/env-constants';

export default {

	getDispatches(filterBy, view, currUserId) {
		const url = `${config.cloudFunctionsBaseUrl}/getDispatches`;
		return axios.post(url, {
			view: view,
			currUserId: currUserId,
			filterBy: JSON.stringify(filterBy)
		});
	},

	saveDispatch(dispatch, currUserId) {
		let url = `${config.cloudFunctionsBaseUrl}/saveDispatch`;
		return axios.post(url, {
			currUserId: currUserId,
			currTimeStamp: DateUtil.getCurrentTimestamp(),
			dispatch: JSON.stringify(dispatch)
		});
	},

	deployDispatch(dispatch, currUserId) {
		let url = `${config.cloudFunctionsBaseUrl}/deployDispatch`;
		return axios.post(url, {
			currUserId: currUserId,
			currTimeStamp: DateUtil.getCurrentTimestamp(),
			dispatch: JSON.stringify(dispatch)
		});
	},

	cancelDispatch(dispatch, currUserId) {
		let url = `${config.cloudFunctionsBaseUrl}/cancelDispatch`;
		return axios.post(url, {
			currUserId: currUserId,
			currTimeStamp: DateUtil.getCurrentTimestamp(),
			dispatch: JSON.stringify(dispatch)
		});
	},

	receiveDispatch(dispatch, currUserId, currTimeStamp) {
		let url = `${config.cloudFunctionsBaseUrl}/receiveDispatch`;
		return axios.post(url, {
			currUserId: currUserId,
			currTimeStamp: currTimeStamp,
			dispatch: JSON.stringify(dispatch)
		});
	},

	validateReceive(dispatch, currUserId) {
		let url = `${config.cloudFunctionsBaseUrl}/validateReceive`;
		return axios.post(url, {
			currUserId: currUserId,
			dispatch: JSON.stringify(dispatch)
		});
	},

	paginateAssetsForDispatch(page, limit, startAt, direction, filters, currUserId) {
        let url = `${config.cloudFunctionsBaseUrl}/paginateAssetsForDispatch`;
        return axios.post(url, { ...filters, page, limit, startAt, direction, currUserId });
    },
}
